module.exports = __webpack_public_path__ + "static/media/airnavireland.63c4b9e2.png";